import { DriverLogoPage } from "./DriverLogoPage";

export const DriverLoadingPage = () => <DriverLogoPage type={"LOADING"} />;
